import {useCallback} from "react";
import {useSelector} from "react-redux";
import {appRatesSelector} from "../slices/appSlice";

const useRate = () => {
  const rates = useSelector(appRatesSelector);

  const getPrice = useCallback((price, priceCurrency, targetCurrency) => {
    if (priceCurrency === targetCurrency) {
      return price;
    } else if (targetCurrency === "USD") {
      return price / rates[priceCurrency];
    } else if (priceCurrency === "USD") {
      return price * rates[targetCurrency];
    } else {
      return price / rates[priceCurrency] * rates[targetCurrency];
    }
  }, [rates]);

  return {getPrice};
};
export default useRate;
